import { useDispatch, useSelector } from 'react-redux';
import { selectLoading, setLoading } from '../dataWranglerSlice';
import LassoSnackbar from '../../../components/LassoSnackbar';

const AQTSnackbar = () => {
    const dispatch = useDispatch();
    const aqtLoading = useSelector(selectLoading);

    const renderContent = () => {
        if (aqtLoading) {
            setTimeout(() => {
                dispatch(setLoading(false));
            }, 3000);

            return <LassoSnackbar
                open={aqtLoading}
                variant="system"
                message="Dictionary Query Tool is processing..."
                closable={false}
            />
        } else {
            return null;
        }

    }
    return (
        renderContent()
    )
}

export default AQTSnackbar